
<template>
  <DataTable :value="items" tableStyle="width: 100%" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]">
    <template #header>
      <div class="flex flex-wrap align-items-center justify-content-between gap-2">
        <span class="text-xl text-900 font-bold">{{header_tab}}</span>
      </div>
    </template>
    <Column field="numero" header="Numero Fattura"></Column>
    <Column field="code" header="Fornitura"></Column>
    <Column field="totale_fattura" header="Totale Fattura">
      <template #body="{data}">
        {{ formatCurrency(data.totale_fattura) }}
      </template>
    </Column>
    <Column field="dep_cauz" header="Deposito Cauzionale">
      <template #body="{data}">
        {{ formatCurrency(data.dep_cauz) }}
      </template>
    </Column>
    <Column field="saldo" header="Totale Pagato">
      <template #body="{data}">
        {{ formatCurrency(data.saldo) }}
      </template>
    </Column>
  </DataTable>
</template>

<script>
  import Service from '@/services/ask-management/contratti-vendita-service'
  import { ref, onMounted, getCurrentInstance } from 'vue';
  import moment from 'moment'

  export default {
    components: {},
    props:{
      data: Array,
      header: String
    },
    setup(props) {
      const loader = ref(false)
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const items = ref()
      const header_tab = ref()

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      }
      onMounted(() => {   
        items.value = props.data
        header_tab.value = props.header
      })

      return { 
        moment,
        loader, 
        service,
        items,
        header_tab,
        formatCurrency,
      }
    }
  }
</script>
<style>
</style>